import type { RouteRecordRaw } from 'vue-router';

export const BRAND_ROUTER: RouteRecordRaw = {
  path: '/admin/brand',
  component: () => import('@/modules/admin/brand/views/List.vue'),
  name: 'Brand List',
  meta: {
    title: '브랜드 관리',
    requiresAuth: true,
    keepAlive: true,
  },
};
